<!-- 水泵节能日报表 -->
<template>
    <div class='container'>
        <el-page-header style="height:40px;line-height:40px;" @back="goBack" content="水泵日报"></el-page-header>
        <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="选择月份">
                <el-date-picker
                    v-model="form.time"
                    type="month"
                    placeholder="选择月份"
                    value-format="yyyy-MM-dd"
                    @change="choseTime">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="charts-box" >
            <div id="charts"  style="width: 100%;height:100%;"></div>
            <div class="nodata" v-show="energy_conservation.length===0">
                --  暂无数据 --
            </div>
        </div>
    </div>
</template>

<script>
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay, getCurrentMonthLast } from '@/utils/utils.js'

var chart1 = null
const mGetDate = function(){
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let d = new Date(year, month, 0);
    return d.getDate();
}

export default {
    name:  'energypumpday',
    data() {
        return {
            form: {
                day: '',
                time: FormatDate('yyyy-MM-dd')
            },
            energy_conservation: [], 
            energy_pump: [],    
        };
    },

    components: {},

    computed: {},

    mounted() {
        this.$nextTick(()=>{

            // 基于准备好的dom，初始化echarts实例
            chart1 = echarts.init(document.getElementById('charts'));

             let time = FormatDate('yyyy-MM-dd')
            this.getTableData(time)
        })
        
    },

    methods: {
        
        async getTableData(time) {
            time = time + ' 11:59:59'
            let time_range = 'day'
            let res = await Service.getPumpStatisticByPIDTimeRange({time_range, time})
            if(res) {
                let list = res.electricity_fee.conservation_electricity_fee
                list = list === null ? [] : list
                this.energy_conservation = list.map(v=>{return v.value})
                let list1 =res.electricity_fee.sum_electricity_fee
                list1 = list1 === null ? [] : list1
                this.energy_pump = list1.map(v=>{return v.value})
                this.initData()
            }
        },
        choseTime(val) {
            if(!val) return
            this.form.time = getCurrentMonthLast(val)
        },
        // 查询
        onSubmit() {
            let time = this.form.time
            this.getTableData(time);
        },
        initData() {
            this.initChart1(this.energy_conservation, this.energy_pump)
        },
        initChart1(nowDay, otherDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                         color: 'rgba(56, 191, 96, 1)'
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                    },
                    data: otherDay,
                },
            ]
            chart1.setOption(option);
        },
        getOption() {
            let Len = mGetDate();
            let Axis = []
            for (let index = 0; index < Len; index++) {
                Axis.push(index+1 + '日')
                
            }
            
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总节约电费', '总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 70,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: Axis
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总节约电费',
                        type: 'bar',
                        stack: '电费',
                        data: [],
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                    },
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: [],
                    },
                ],
            }
        },
        goBack() {
            this.$router.go(-1);//返回上一层
        }
    }
}

</script>
<style lang='less' scoped>
.charts-box{
    width: 60%;
    height: 400px;
    margin: 100px auto 0;
    #charts{
        width: 100%;
        height: 100%;
    }
}
.situation-list{
    margin: 10px;
    .situation-flex{
        display: flex;
        flex-direction: row;
        span{
            flex: 1;
            text-align: left;
            font-size: 14px;
            color: #666;
            line-height: 40px;
            margin: 5px 0;
            text-align: left;
            padding: 0 20px;
        }
    }
}
</style>